var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-section',_vm._b({attrs:{"flex":"","center-items":"","area":"hero"}},'b-section',_vm.$attrs,false),[(_vm.hasSlot)?_c('div',{staticClass:"hero__content-wrapper mt-90"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }